export const DOWNLOADS_CURRENTLY_RUNNING_TOAST_ID = 'DOWNLOADS_CURRENTLY_RUNNING';